import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from './core/services/environment.service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from './core/services/storage.service';
import { FeatureTogglerService } from './core/services/feature-toggler.service';
import { LoggerService } from './core/services/logger.service';
import { logger } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  public currentStore: string;
  public currentTheme: string;
  constructor(
    private envService: EnvironmentService,
    private translateService: TranslateService,
    private storageService: StorageService,
    private toggleFeatureService: FeatureTogglerService,
    private loggerService: LoggerService,
  ) {
  }

  ngOnInit(): void {
    this.currentStore = this.envService.setStore(this.envService.getStore());
    this.translateService.setDefaultLang('en');
    this.translateService.use('en');
    this.toggleFeatureService.loadFeatureToggler();
    this.loggerService.setLogType(logger);
    this.currentTheme = this.envService.getTheme();
  }

  public checkQueryString(queryString: string) {

    if (queryString) {
      queryString = queryString.substring(1);
      const queryParams = queryString.split('&');

      queryParams.forEach( (query, index) => {
        const queryPair = query.split('=');
        // Save the store parameter if exists
        switch(queryPair[0]) {
          case 'theme':
          case 'store':
              this.currentStore = this.envService.setStore(queryPair[1]);
           break;

          case 'access_token':
            this.storageService.setLocalItem( queryPair[0], queryPair[1] );
            break;

          case 'expires_in':
            this.storageService.setLocalItem( queryPair[0], queryPair[1] );
            break;

          case 'lang':
          // this.storageService.setLocalItem( queryPair[0], queryPair[1] );
          this.translateService.use(queryPair[1]);
          break;
        }
      });
    }
  }


}


// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/app.component.ts